import { Component, Input, OnInit } from '@angular/core'
import { GrowthToolkitKPI } from 'src/app/shared/services/ppv.api'

@Component({
   selector: 'action-item-expandable-row',
   templateUrl: './action-item-expandable-row.component.html',
   styleUrls: ['./action-item-expandable-row.component.scss'],
   standalone: false,
})
export class GrowthToolkitActionItemExpandableRowComponent implements OnInit {
   @Input() taskId: string
   @Input() title: string
   @Input() subtitle?: string
   @Input() units?: string
   @Input() kpis: string[] = []
   @Input() kpiMap: { [key: number]: GrowthToolkitKPI } = {}
   @Input() vetcorAvg?: string = '0.0'
   @Input() current?: number = 0.0
   @Input() target?: number
   @Input() barColor = '#1bb3ae' // default teal
   @Input() editable = true
   @Input() toggleEnabled?: boolean = false
   @Input() isPublished?: boolean

   expanded = false

   colorMap: { [key: string]: string } = {
      '1': '#1bb3ae', // teal
      '2': '#831182', // purple
      '3': '#ed5d21', // dark orange
      '4': '#fdb813', // yellow
      '5': '#0073cc', // blue
      '6': '#f08c1c', // orange
   }

   //prettier-ignore
   constructor(
   ) {}

   ngOnInit(): void {}

   toggleExpand() {
      this.expanded = !this.expanded
   }

   getTarget(): string | number {
      return this.target
   }

   getActionItemDataToSave(): ActionItemDataToSave {
      return {
         taskId: this.taskId,
         vetcorAvg: this.vetcorAvg,
         currentValue: this.current,
         targetValue: this.target,
         isActive: this.toggleEnabled,
         isPublished: this.isPublished,
      }
   }
}

export interface ActionItemDataToSave {
   taskId: string
   vetcorAvg: string
   currentValue: number
   targetValue: number
   isActive: boolean
   isPublished: boolean
}
